// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOME_SHOW_MORE_POSTS = "Zobraz \u010fal\u0161ie";
